module.exports = __webpack_public_path__ + "static/media/pernelongo-de-costas-brancas.6f63cfb8.png";